import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../assets/img/patient.jpg";
import { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../components/text-area";
import { prompts } from "../../../util/dummyJson";
import { ADMIN_USER_CLINICIANS, ADMINPROMPTS } from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import { showToast } from "../../../util/toastHelper";
import arrorRight from "../../../assets/img/arrow-right.svg";
import { ADMINPROMPTSADD, ADMINPROMPTSEDIT } from "../../../util/path";
import Loading from "react-fullscreen-loading";
import UserDetailsModal from "../../../components/adminClinicalsUserModal/UserDetailsModal";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminUserCliniciansList = () => {
  const [isLoading, setIsLoading] = useState(true);

  const [userCliniciansList, setUserCliniciansList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [userData, setUserData] = useState(null);

  const handleUserDetailsModal = async (userId) => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", `${ADMIN_USER_CLINICIANS}/${userId}`);
      if (response?.res?.status === 200) {
        setUserData(response?.res?.data?.data);
        setShowModal(true);
      } else {
        console.error("Failed to fetch user details");
      }
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUserCliniciansData();
  }, []);


  const getUserCliniciansData = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", ADMIN_USER_CLINICIANS);
      if (response.res.status == 200) {
        setUserCliniciansList(response?.res?.data?.data?.clinicians);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const changeBanUnban = async (cliniciansId, is_banned) => {
    const result = await MySwal.fire({
      title: is_banned
        ? "Are you sure you want to unban this user?"
        : "Are you sure you want to ban this user?",
      text: is_banned
        ? "This user will be unbanned & able to access the system."
        : "This user will be banned & unable to access the system.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: is_banned ? "Yes, unban it!" : "Yes, ban it!",
      cancelButtonText: "Cancel"
    });

    if (result.isConfirmed) {
      setIsLoading(true);
      try {
        const response = await CallWithAuth("POST", `${ADMIN_USER_CLINICIANS}/${cliniciansId}/ban`, { isBanned: !is_banned });
        if (response?.res?.data?.statusCode === 200 || response?.res?.data?.statusCode === 201) {
          const action = is_banned ? "unbanned" : "banned";
          showToast("success", `Clinicians has been ${action} successfully`);
          await getUserCliniciansData();
        } else {
          showToast("error", response?.res?.data?.message);
        }
      } catch (error) {
        showToast("error", "An error occurred while processing your request.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <Loading
            loading
            background="rgba(236, 240, 241, 0.7)"
            loaderColor="#3498db"
          />
        </>
      )}
      <div>
        <section className="site_hero patient_management_banner">
          <div className="site_container">
            <div className="site_row">
              <div className="txt_colm">
                <div className="txt_block">
                  <h1>Manage Users</h1>
                  <p>Manage each Users efficiently</p>
                </div>
              </div>
              <div className="img_colm">
                <div className="img_block">
                  <img src={patient} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="site_container">
          <div className="patient_form_block">
            <table className="table patient-row-details m-0">
              <thead>
                <tr>
                  <th width="15%">Email</th>
                  <th width="15%">Role</th>
                  <th width="15%">Created At</th>
                  <th width="10%" className="text-center">Active/Inactive</th>
                  <th width="15%" className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(userCliniciansList) && userCliniciansList.length > 0 && (
                  <>
                    {userCliniciansList.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.email}</td>
                        <td>{item?.role}</td>
                        <td>{item?.created_at}</td>
                        <td className="text-center">
                          <div className="form-check form-switch d-inline-block">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id={`toggle-${item.id}`}
                              checked={item.is_banned}
                              onChange={() => changeBanUnban(item.id, item.is_banned)}
                            />
                            <label className="form-check-label" htmlFor={`toggle-${item.id}`}></label>
                          </div>
                        </td>
                        <td
                          className="d-flex gap-3 text-center patient-informartion-action"
                          style={{ flexWrap: "wrap", justifyContent: "center" }}
                        >
                          {/* <button
                            onClick={() =>
                              navigate(`${ADMINPROMPTSEDIT}/${item?.id}`)
                            }
                            className="edit"
                          >
                            <i className="fa-solid fa-info"></i>
                          </button> */}
                          <button
                            onClick={() => handleUserDetailsModal(item?.id)}
                            className="edit"
                          >
                            <i className="fa-solid fa-info"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
            {userCliniciansList.length > 0 == 0 && (
              <h1 style={{ textAlign: "center" }}>No Clinicians Found</h1>
            )}
          </div>
        </section>
      </div>
      {showModal && <UserDetailsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        userData={userData}
      />}
      <ToastContainer />
    </>
  );
};
export default AdminUserCliniciansList;
